import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src", "alt", "width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("img", {
    src: _ctx.iconContent,
    alt: _ctx.iconAlt,
    width: _ctx.width,
    height: _ctx.height,
    style: _normalizeStyle(_ctx.iconStyle)
  }, null, 12, _hoisted_1);
}